import { render, staticRenderFns } from "./viewMultipleFeedback.vue?vue&type=template&id=7525fff0&"
import script from "./viewMultipleFeedback.vue?vue&type=script&lang=js&"
export * from "./viewMultipleFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports